import router from '.';

import store from '@/store';

export async function handlePostLoginRedirect(ssoUser?: boolean | undefined): Promise<void> {
  const currentUser = store.getters['user/getCurrentUser'];

  if (!currentUser) {
    router.push({ name: 'Login' });
    return;
  }

  if (!currentUser.organization) {
    router.push({ name: 'ContentLabAlreadyLoggedIn' });
    return;
  }

  const enableStudioMagiclinkInvalidation = store.getters['org/getCurrentOrg']?.enableStudioMagiclinkInvalidation;
  if (enableStudioMagiclinkInvalidation && !ssoUser) {
    await store.dispatch('user/checkForceChangePassword');
    if (store.state.user.forceChangePassword) {
      router.push({
        name: 'External',
        query: { isFirstTime: '1' }
      });
      return;
    }
  }

  const redirect = router.currentRoute.value.query.redirect || '';
  const hash = fireActionFromHash(router.currentRoute.value.hash);
  const redirectUrl = redirect ? redirect + hash : '';

  if (redirectUrl) {
    router.push(`/${redirectUrl}`);
    return;
  }

  router.push({ name: 'OrgHome' });
}

/**
 * This function is used during the initial app load to trigger actions based on the URL hash.
 * Side effects from this should be used sparingly and the hash could be used to directly update the UI.
 * However, in certain cases where direct UI update is difficult, this function can be used to trigger side effects.
 *
 * @param hash The hash from the URL.
 * @returns `hash | ''` The original hash if it was not consumed by this function, or an empty string if it was consumed.
 */
export function fireActionFromHash(hash: string): string {
  if (!hash) {
    return '';
  }

  // if (hash === '#hash-to-consume') {
  //   Do something
  //   return '';
  // }

  return hash;
}
